var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectionValidator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "744px",
    height: "650px",
    viewBox: "0 0 744 650",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-42.9%",
    width: "185.7%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-42.9%",
    width: "185.7%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.9098054%",
    y1: "89.4508407%",
    x2: "23.6596906%",
    y2: "20.7408879%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "28.7769784 159.205779 78.8980879 148.706735 72.4419817 96.7479432 129.95564 86.0460708 121.016622 24.8105436 185.379693 15.1495017 221.66285 221.914482 37.3354074 239.648569"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-2.9%",
    width: "108.8%",
    height: "107.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232993197   0 0 0 0 0.232993197   0 0 0 0 0.232993197  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.2925507%",
    y1: "35.3871037%",
    x2: "63.0299159%",
    y2: "69.3932519%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7FA7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "2.39530294%",
    x2: "100%",
    y2: "88.0026218%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A091FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6758FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 0.799360512,
    y: 48.6378738,
    width: 38.3693046,
    height: 13.5548173,
    rx: 6.77740864
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-18.4%",
    width: "118.2%",
    height: "151.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-10",
    cx: 54.756195,
    cy: 17.9401993,
    rx: 2.79776179,
    ry: 2.79069767
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-62.6%",
    y: "-44.8%",
    width: "225.1%",
    height: "225.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-12",
    cx: 80.3357314,
    cy: 5.18272425,
    rx: 5.19584333,
    ry: 5.18272425
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.7%",
    y: "-24.1%",
    width: "167.4%",
    height: "167.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-14",
    points: "28.7769784 159.205779 78.8980879 148.706735 72.4419817 96.7479432 129.95564 86.0460708 121.016622 24.8105436 185.379693 15.1495017 221.66285 221.914482 37.3354074 239.648569"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-2.9%",
    width: "108.8%",
    height: "107.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232993197   0 0 0 0 0.232993197   0 0 0 0 0.232993197  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-16",
    x: 0.799360512,
    y: 48.6378738,
    width: 38.3693046,
    height: 13.5548173,
    rx: 6.77740864
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-18.4%",
    width: "118.2%",
    height: "151.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-18",
    cx: 54.756195,
    cy: 17.9401993,
    rx: 2.79776179,
    ry: 2.79069767
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-62.6%",
    y: "-44.8%",
    width: "225.1%",
    height: "225.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-20",
    cx: 80.3357314,
    cy: 5.18272425,
    rx: 5.19584333,
    ry: 5.18272425
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.7%",
    y: "-24.1%",
    width: "167.4%",
    height: "167.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StaFihub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2",
    transform: "translate(-545.000000, -1685.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(695.000000, 1835.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-23",
    fill: "#FFD5E2",
    opacity: 0.385756341,
    filter: "url(#filter-1)",
    cx: 269,
    cy: 175,
    r: 175
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-23-Copy",
    fill: "#6758FF",
    opacity: 0.385756341,
    filter: "url(#filter-2)",
    cx: 175,
    cy: 175,
    r: 175
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(29.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.235919,107.654826 C177.343375,79.925584 189.260727,61.3163897 190.987976,51.8272425 L220.966388,221.211008 L42.3661071,238.917565 C54.6981898,217.574942 64.3357147,202.399913 71.2786818,193.39248 C78.8720065,183.541308 95.7143307,172.904495 100.327757,165.541779 C116.739054,139.350458 122.074735,149.248688 155.235919,107.654826 Z",
    id: "Rectangle-11",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-11",
    fill: "url(#linearGradient-7)",
    points: "170.192424 173.924076 206.183715 135.548173 221.351724 221.256565 123.900879 230.636128"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-12",
    transform: "translate(19.984013, 55.415282) rotate(38.000000) translate(-19.984013, -55.415282) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF82AA",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6A5BFF",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy",
    transform: "translate(289.000000, 120.000000) scale(-1, 1) translate(-289.000000, -120.000000) translate(178.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.235919,107.654826 C177.343375,79.925584 189.260727,61.3163897 190.987976,51.8272425 L220.966388,221.211008 L42.3661071,238.917565 C54.6981898,217.574942 64.3357147,202.399913 71.2786818,193.39248 C78.8720065,183.541308 95.7143307,172.904495 100.327757,165.541779 C116.739054,139.350458 122.074735,149.248688 155.235919,107.654826 Z",
    id: "Rectangle-11",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-11",
    fill: "url(#linearGradient-7)",
    points: "170.192424 173.924076 206.183715 135.548173 221.351724 221.256565 123.900879 230.636128"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-12",
    transform: "translate(19.984013, 55.415282) rotate(38.000000) translate(-19.984013, -55.415282) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF82AA",
    fillRule: "evenodd",
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-21)",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6A5BFF",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectionValidator);
export default __webpack_public_path__ + "static/media/election_validator.dff95152058279fa4daac69f6eabb6dc.svg";
export { ForwardRef as ReactComponent };